var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportingAnalytical = function SvgReportingAnalytical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 18.21,
    y1: 175.79,
    x2: 157.61,
    y2: 17.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 36.62,
    y1: 192.04,
    x2: 176.03,
    y2: 34,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 71.57,
    y1: 222.87,
    x2: 210.98,
    y2: 64.83,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 94.95,
    y1: 243.49,
    x2: 234.36,
    y2: 85.45,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 3.57,
    y1: 162.88,
    x2: 142.98,
    y2: 4.84,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M30.01,143.34H10.01c-5.52,0-9.99,4.48-10,10v43.33c0,1.84,1.49,3.33,3.33,3.33h33.33c1.84,0,3.33-1.49,3.33-3.33v-43.33c0-5.52-4.48-9.99-10-10ZM33.34,193.33H6.68v-39.99c0-1.84,1.49-3.33,3.33-3.33h20c1.84,0,3.33,1.49,3.33,3.33v39.99h0Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33,96.68h-20c-5.52,0-9.99,4.48-10,10v89.99c0,1.84,1.49,3.33,3.33,3.33h33.33c1.84,0,3.33-1.49,3.33-3.33v-89.99c0-5.52-4.48-9.99-10-10ZM86.67,193.33h-26.66v-86.65c0-1.84,1.49-3.33,3.33-3.33h20c1.84,0,3.33,1.49,3.33,3.33v86.65h0Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,116.68h-20c-5.52,0-9.99,4.48-10,10v69.99c0,1.84,1.49,3.33,3.33,3.33h33.33c1.84,0,3.33-1.49,3.33-3.33v-69.99c0-5.52-4.48-9.99-10-10ZM139.99,193.33h-26.66v-66.66c0-1.84,1.49-3.33,3.33-3.33h20c1.84,0,3.33,1.49,3.33,3.33v66.66h0Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.99,90.02h-20c-5.52,0-9.99,4.48-10,10v96.65c0,1.84,1.49,3.33,3.33,3.33h33.33c1.84,0,3.33-1.49,3.33-3.33v-96.65c0-5.52-4.48-9.99-10-10ZM193.32,193.33h-26.66v-93.32c0-1.84,1.49-3.33,3.33-3.33h20c1.84,0,3.33,1.49,3.33,3.33v93.32h0Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.06,39.95c6.11,6.87,16.11,8.69,24.25,4.41,8.14-4.28,12.3-13.56,10.09-22.48-2.21-8.92-10.22-15.19-19.41-15.18-6.67,0-12.91,3.32-16.62,8.87-3.71,5.55-4.41,12.58-1.86,18.75l-19.92,12.45c-3.58-4.06-8.67-6.49-14.08-6.72-5.41-.23-10.68,1.76-14.6,5.5l-21.81-16.36c4.61-8.92,1.89-19.88-6.36-25.61-8.25-5.73-19.47-4.45-26.21,2.99-6.75,7.44-6.93,18.73-.43,26.38l-27.94,33.21c-8.96-5.27-20.46-2.8-26.47,5.69-6,8.49-4.5,20.16,3.45,26.85,7.96,6.69,19.71,6.17,27.05-1.2,7.33-7.37,7.8-19.13,1.07-27.05l27.94-33.21c7.67,4.56,17.45,3.45,23.89-2.73l21.81,16.36c-4.25,8.22-2.29,18.29,4.72,24.32,7.01,6.04,17.26,6.47,24.76,1.05,7.5-5.42,10.3-15.28,6.76-23.84l19.92-12.45ZM179.99,13.36c7.36,0,13.33,5.97,13.33,13.33,0,7.36-5.97,13.32-13.33,13.33-7.36,0-13.33-5.97-13.33-13.33s5.97-13.33,13.33-13.33ZM20.01,96.68c-7.36,0-13.33-5.97-13.33-13.33s5.97-13.33,13.33-13.33,13.33,5.97,13.33,13.33c0,7.36-5.97,13.32-13.33,13.33ZM73.34,33.36c-7.36,0-13.33-5.97-13.33-13.33s5.97-13.33,13.33-13.33,13.33,5.97,13.33,13.33c0,7.36-5.97,13.32-13.33,13.33ZM126.66,73.35c-7.36,0-13.33-5.97-13.33-13.33s5.97-13.33,13.33-13.33,13.33,5.97,13.33,13.33c0,7.36-5.97,13.32-13.33,13.33Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }));
};
export default SvgReportingAnalytical;